import React from 'react';
import  {useState} from "react";
import InputMask from 'react-input-mask';
import { Input } from 'reactstrap';
import { cnpj } from 'cpf-cnpj-validator';

function CNPJ(props) {

    let [value,updateValue] = useState(props.value?props.value:'');
    let [error,updateError] = useState(props.error?props.error:'');
    let className = '';

    const handleChange = element => {
        let elementValue = element.target.value;
        if (elementValue.length == 18 && !cnpj.isValid(elementValue)) {
            elementValue = '';
        }
        updateValue(elementValue);
        props.onChange(element);
    };

    if(props.error){
        className="is-invalid";
    }

    return (
        <div>
            <Input
                type="text"
                mask="99.999.999/9999-99"
                maskChar=''
                tag={InputMask}
                className={className}

                id={'id_'+props.name} 
                name={props.name} 
                onChange={handleChange}
                value={value}
                readOnly={props.readOnly}
                autoFocus={props.autoFocus?true:false}
            />
            {props.error && (
                <span id="terms-error" className="error invalid-feedback" style={{display:'inline'}}>{props.error}</span>
            )}
        </div>
    );

}
export default CNPJ;
